// extracted by mini-css-extract-plugin
export default {"RefDataManagement":"styles_RefDataManagement__Vlicc","container":"styles_container__NBRs0"};